// import React from 'react';
import Dashboard from 'containers/Dashboard'
import BookingsTable from 'containers/Dashboard/Bookings/BookingsTable'
import OfferingCategories from 'containers/Dashboard/OfferingCategory'
import Offerings from 'containers/Dashboard/Offering'
import ListOfferingCategory from 'containers/Dashboard/OfferingCategory/ListOfferingCategory'
import AddOfferingCategory from 'containers/Dashboard/OfferingCategory/AddOfferingCategory'
import EditOfferingCategory from 'containers/Dashboard/OfferingCategory/EditOfferingCategory'
import ListOffering from 'containers/Dashboard/Offering/ListOffering'
import AddOffering from 'containers/Dashboard/Offering/AddOffering'
import EditOffering from 'containers/Dashboard/Offering/EditOffering'
import OfferingTag from 'containers/Dashboard/OfferingTag'
import ListOfferingTag from 'containers/Dashboard/OfferingTag/ListOfferingTag'
import AddOfferingTag from 'containers/Dashboard/OfferingTag/AddOfferingTag'
import EditOfferingTag from 'containers/Dashboard/OfferingTag/EditOfferingTag'
import DeityLayout from 'containers/Dashboard/Deities'
import ListDeity from 'containers/Dashboard/Deities/ListDeity'
import EditDeity from 'containers/Dashboard/Deities/EditDeity'
import AddDeity from 'containers/Dashboard/Deities/AddDeity'
import ReceiptLayout from 'containers/Dashboard/Bookings/ReceiptLayout'
import Bookings from 'containers/Dashboard/Bookings'
import TempleProfile from 'containers/Dashboard/TempleProfile'
import DonationCategories from 'containers/Dashboard/DonationCategories'
import AddDonationCategory from 'containers/Dashboard/DonationCategories/AddDonationCategory'
import EditDonationCategory from 'containers/Dashboard/DonationCategories/EditDonationCategory'
import ListDonationCategory from 'containers/Dashboard/DonationCategories/ListDonationCategory'
import Donation from 'containers/Dashboard/Donation'
import AddDonation from 'containers/Dashboard/Donation/AddDonation'
import EditDonation from 'containers/Dashboard/Donation/EditDonation'
import ListDonation from 'containers/Dashboard/Donation/ListDonation'
import Report from 'containers/Dashboard/reports/Reports'
import ReportTable from 'containers/Dashboard/reports/ReportTable'
import DonationBooking from 'containers/Dashboard/DonationBooking'
import DonationBookingTable from 'containers/Dashboard/DonationBooking/DonationBookingTable'
import DonationReceiptLayout from 'containers/Dashboard/DonationBooking/DonationReceiptLayout'
import ManageUsers from 'containers/Dashboard/ManageUsers'
import UsersList from 'containers/Dashboard/ManageUsers/UsersList'
import Permissions from 'containers/Dashboard/ManageUsers/Permissions'
import OfferingPool from 'containers/Dashboard/OfferingPool'
import ListOfferingPool from 'containers/Dashboard/OfferingPool/ListOfferingPool'
import StaffProfiles from 'containers/Dashboard/StaffProfiles'
import ListStaffProfile from 'containers/Dashboard/StaffProfiles/ListStaffProfile'
import AddStaffProfile from 'containers/Dashboard/StaffProfiles/AddStaffProfile'
import EditStaffProfile from 'containers/Dashboard/StaffProfiles/EditStaffProfile'
import StaffTimeOff from 'containers/Dashboard/StaffTimeOff'
import ListStaffTimeOff from 'containers/Dashboard/StaffTimeOff/ListStaffTimeOff'
import AddStaffTimeOff from 'containers/Dashboard/StaffTimeOff/AddStaffTimeOff'
import EditStaffTimeOff from 'containers/Dashboard/StaffTimeOff/EditStaffTimeOff'
import StaffCalendar from 'containers/Dashboard/StaffCalendar'
import StaffAssignments from 'containers/Dashboard/StaffAssignments'
import ListStaffAssignment from 'containers/Dashboard/StaffAssignments/ListStaffAssignment'
import AddStaffAssignment from 'containers/Dashboard/StaffAssignments/AddStaffAssignment'
import EditStaffAssignment from 'containers/Dashboard/StaffAssignments/EditStaffAssignment'

export const dashboardConfig = [
  {
    auth: ['user'],
    component: Dashboard,
    path: '/dashboard',
    routes: [
      // {
      //   path: '/dashboard/bookings',
      //   // component: React.lazy(() => import('containers/Dashboard/Bookings')),
      //   component: Bookings,
      //   routes: [
      //     {
      //       path: '/dashboard/bookings/:id',
      //       component: ReceiptLayout
      //     },
      //     {
      //       path: '/dashboard/bookings',
      //       component: BookingsTable
      //     }
      //   ]
      // },
      // {
      //   path: '/dashboard/donation-receipts',
      //   // component: React.lazy(() => import('containers/Dashboard/Bookings')),
      //   component: DonationBooking,
      //   routes: [
      //     {
      //       path: '/dashboard/donation-receipts/:id',
      //       component: DonationReceiptLayout
      //     },
      //     {
      //       path: '/dashboard/donation-receipts',
      //       component: DonationBookingTable
      //     }
      //   ]
      // },
      {
        path: '/dashboard/profile',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: TempleProfile
      },
      {
        path: '/dashboard/deities',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: DeityLayout,
        routes: [
          {
            path: '/dashboard/deities/add',
            component: AddDeity
          },
          {
            path: '/dashboard/deities/edit/:id',
            component: EditDeity
          },
          {
            path: '/dashboard/deities',
            component: ListDeity
          }
        ]
      },
      {
        path: '/dashboard/offering-categories',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: OfferingCategories,
        routes: [
          {
            path: '/dashboard/offering-categories/add',
            component: AddOfferingCategory,
          },
          {
            path: '/dashboard/offering-categories/edit/:id',
            component: EditOfferingCategory
          },
          {
            path: '/dashboard/offering-categories',
            component: ListOfferingCategory,
          },
        ]
      },
      {
        path: '/dashboard/offering-pools',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: OfferingPool,
        routes: [
          {
            path: '/dashboard/offering-pools',
            component: ListOfferingPool,
          },
        ]
      },
      {
        path: '/dashboard/staff-profiles',
        component: StaffProfiles,
        routes: [
          {
            path: '/dashboard/staff-profiles/add',
            component: AddStaffProfile,
          },
          {
            path: '/dashboard/staff-profiles/edit/:id',
            component: EditStaffProfile,
          },
          {
            path: '/dashboard/staff-profiles',
            component: ListStaffProfile,
          },
        ]
      },
      {
        path: '/dashboard/staff-time-off',
        component: StaffTimeOff,
        routes: [
          {
            path: '/dashboard/staff-time-off/add',
            component: AddStaffTimeOff,
          },
          {
            path: '/dashboard/staff-time-off/edit/:id',
            component: EditStaffTimeOff,
          },
          {
            path: '/dashboard/staff-time-off',
            component: ListStaffTimeOff,
          },
        ]
      },
      {
        path: '/dashboard/staff-calendar',
        component: StaffCalendar,
      },
      {
        path: '/dashboard/staff-assignments',
        component: StaffAssignments,
        routes: [
          {
            path: '/dashboard/staff-assignments/add',
            component: AddStaffAssignment,
          },
          {
            path: '/dashboard/staff-assignments/edit/:id',
            component: EditStaffAssignment,
          },
          {
            path: '/dashboard/staff-assignments',
            component: ListStaffAssignment,
          },
        ]
      },
      {
        path: '/dashboard/offering-tags',
        component: OfferingTag,
        routes: [
          {
            path: '/dashboard/offering-tags/add',
            component: AddOfferingTag,
          },
          {
            path: '/dashboard/offering-tags/edit-group/:name',
            component: EditOfferingTag
          },
          {
            path: '/dashboard/offering-tags/edit/:id',
            component: EditOfferingTag
          },
          {
            path: '/dashboard/offering-tags',
            component: ListOfferingTag,
          },
        ]
      },
      {
        path: '/dashboard/offerings',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: Offerings,
        routes: [
          {
            path: '/dashboard/offerings/add',
            component: AddOffering
          },
          // {
          //   path: '/dashboard/offerings/edit/:id',
          //   component: EditOffering
          // },
          {
            path: '/dashboard/offerings',
            component: ListOffering
          }
        ]
      },
      // {
      //   path: '/dashboard/offerings-completion',
      //   // component: React.lazy(() => import('containers/Dashboard/Bookings')),
      //   component: OfferingCompletion,
      //   routes: [
      //     {
      //       path: '/dashboard/offerings-completion',
      //       component: OfferingCompletionTable
      //     },

      //   ]
      // },
      {
        path: '/dashboard/donation-categories',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: DonationCategories,
        routes: [
          {
            path: '/dashboard/donation-categories/add',
            component: AddDonationCategory,
          },
          {
            path: '/dashboard/donation-categories/edit/:id',
            component: EditDonationCategory
          },
          {
            path: '/dashboard/donation-categories',
            component: ListDonationCategory,
          },
        ]
      },
      {
        path: '/dashboard/donations',
        // component: React.lazy(() => import('containers/Dashboard/Bookings')),
        component: Donation,
        routes: [
          {
            path: '/dashboard/donations/add',
            component: AddDonation
          },
          {
            path: '/dashboard/donations/edit/:id',
            component: EditDonation
          },
          {
            path: '/dashboard/donations',
            component: ListDonation
          }
        ]
      },
      // {
      //   path: '/dashboard/reports',
      //   // component: React.lazy(() => import('containers/Dashboard/Bookings')),
      //   component: Report,
      //   routes: [
      //     {
      //       path: '/dashboard/reports',
      //       component: ReportTable
      //     }
      //   ]
      // },
      {
        path: '/dashboard/manage-users',
        component: ManageUsers,
        routes: [
          {
            path: '/dashboard/manage-users',
            component: UsersList,
            exact: true
          },
          {
            path: '/dashboard/manage-users/:id',
            component: Permissions,
            exact: true
          }
        ]
      }
    ],
  },
];
